import React, { useEffect, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "../../components/Button";
import Footer from "../../components/Footer";
import Navbar from "../../components/NavBar";
import "./index.css";
//import PhoneInput, { formatPhoneNumber } from "react-phone-number-input";
//import "react-phone-number-input/style.css";
import budPayImg from "../../assets/img/budPay.jpeg";
import flutterwave from "../../assets/img/flutterwave_logo_color.svg";
import nb from "../../assets/img/nb.png";
import nombaLogo from "../../assets/img/nomba.svg";
import paystack from "../../assets/img/Paystack-CeruleanBlue-StackBlue-HL.png";
import PickupImage from "../../assets/img/pickup.png";
import errorIcon from "../../assets/img/x-circle.png";
// import InputField from "../../components/InputField";
import Modal from "../../components/Modal";
// import woven from "../../assets/img/Woven_Forly.svg";
import azaPayLogo from "../../assets/img/azapay-logo.png";
import wallet from "../../assets/img/wallet-icon.png";
import Loading from "../../components/Loading";
import ButtonComponent from "../../components/otpinput";
import apiroutes from "../../services/apiroutes";
import {
  requestBooking,
  requestPayment,
  requestSetting,
} from "../../services/apiservice";
import { requestWallet } from "../../services/apiserviceWallet";
import {
  getAuth,
  getAuthWallet,
  getUserCashbackWallet,
  getUserWallet,
  setUserCashbackWallet,
  setUserWallet,
} from "../../services/auth";
import makeAPICallAzaPay from "../../services/azaPay";
import makeAPICallBudPay from "../../services/budPay";
import makeAPICall from "../../services/paystackPay";
// import makeAPICallFlutter from "../../services/flutterwavePay";

import personaldetailscircle from "../../assets/img/personaldetails-circle.png";
import personaldetailslongcone from "../../assets/img/personaldetails-longcone.png";
import personaldetailsshortcone from "../../assets/img/personaldetails-shortcone.png";
// import "antd/dist/antd.css";
import { Steps, theme } from "antd";
import InputField from "../../components/InputField";
import config from "../../configs";
import { getUser } from "../../services/auth";
import MobileNavBar from "../UserProfile/MobileNavbar";
import SideBar from "../UserProfile/SideBar";

// import Loader from "../../components/Loader";

export const DetailsComponent = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    localStorage.removeItem("walletPin");
    getAllPaymentGateways();
  }, []);
  useEffect(() => {
    const tripInfoo = JSON.parse(localStorage.getItem("selectedBusData"));
    // tripInfoo = tripInfoo === null || tripInfoo === undefined || tripInfoo === "" ? history.push("/") : JSON.parse(tripInfoo);
    setTripInfo(JSON.parse(localStorage.getItem("selectedBusData")));
  }, []);
  useEffect(() => {
    const userTripDetails = localStorage.getItem("allTripDetails");
    const data = JSON.parse(userTripDetails);
    // const data = userTripDetails === null || userTripDetails === undefined || userTripDetails === "" ? history.push("/") : JSON.parse(userTripDetails);
    setData(data);
    let userSelectedSeatt = localStorage.getItem("selectedSeats");
    userSelectedSeatt = JSON.parse(userSelectedSeatt);
    // userSelectedSeatt = userSelectedSeatt === null || userSelectedSeatt === undefined || userSelectedSeatt === "" ? history.push("/") : JSON.parse(userSelectedSeatt);
    setUserSelectedSeat(userSelectedSeatt);
    let userSelectedReturnedSeatt = localStorage.getItem("selectedSeatsReturn");
    // userSelectedSeatt = JSON.parse(userSelectedSeatt);
    userSelectedReturnedSeatt =
      userSelectedReturnedSeatt === null ||
      userSelectedReturnedSeatt === undefined ||
      userSelectedReturnedSeatt === ""
        ? null
        : JSON.parse(userSelectedReturnedSeatt);
    setUserSelectedSeatReturn(userSelectedReturnedSeatt);
    // let userInfoo = localStorage.getItem("userSelect");
    // userInfoo = userInfoo === null || userInfoo === undefined || userInfoo === "" ? history.push("/") : JSON.parse(userInfoo);
    let adults = localStorage.getItem("adults");
    adults = JSON.parse(adults);
    let adultsRound = localStorage.getItem("adultsRound");
    adultsRound = JSON.parse(adultsRound);
    // adults = adults === null || adults === undefined || adults === "" ? history.push("/") : JSON.parse(adults);
    let noOfAdult = adults || adultsRound;
    if (noOfAdult === null || noOfAdult === undefined || noOfAdult === "") {
      history.push("/");
    }
    // setAdult(parseInt(noOfAdult));
    // let noOfAdult = parseInt(adults);
    handleAddFields(noOfAdult - 1);
    // setUserInfo(userInfoo)

    // let returnTripInfoo = localStorage.getItem("selectedReturnBusData");
    // returnTripInfoo = returnTripInfoo === null || returnTripInfoo === undefined || returnTripInfoo === "" ? history.push("/") :JSON.parse(returnTripInfoo);
    // setReturnTripInfo(returnTripInfoo)
    // eslint-disable-next-line
  }, []);

  const history = useHistory();
  const loggedInUser = getUser();
  const walletUser = getUserWallet();
  const cashbackWalletUser = getUserCashbackWallet();
  const walletDetails = getAuthWallet();
  const [loader, setLoader] = useState(true);
  const [loadingLoading, setLoadingLoading] = useState(false);
  const [modalVisible, setVisible] = useState(false);
  const [modalVisibleAmount, setVisibleAmount] = useState(false);
  const [modalVisiblePin, setVisiblePin] = useState(false);
  const [modalVisiblePickup, setVisiblePickup] = useState(false);
  const [modalVisiblePayBooking, setVisiblePayBooking] = useState(false);
  const [walletState, setWalletState] = useState(false);
  const [cashbackWalletState, setCashbackWalletState] = useState(false);
  const [value, setValue] = useState();
  const [valueTwo, setValueTwo] = useState("");
  const [fullName, setFullName] = useState("");
  const [lastName, setLastName] = useState("");
  const [kinName, setKinName] = useState("");
  const [email, setEmail] = useState("");
  const [otpInput, setOtpInput] = useState();
  const [gender, setGender] = useState("");
  const [pageLoading, setPageLoading] = useState(false);
  const userToken = getAuth();
  const [inputList, setInputList] = useState([{ fullName: "", Gender: "" }]);
  const [isActive, setIsActive] = useState(false);
  const [passengerTwo, setPassengerTwo] = useState(false);
  const [beneficiaryNameSet, setBeneficiaryNameSet] = useState(false);
  const [data, setData] = useState({});
  const [userSelectedSeat, setUserSelectedSeat] = useState([]);
  const [userSelectedSeatReturn, setUserSelectedSeatReturn] = useState([]);
  const [modalVisiblePopup, setVisiblePopup] = useState(false);
  // const [userInfo, setUserInfo] = useState({});
  // const [adult, setAdult] = useState("");
  const [alternativeDate, setAlternativeDates] = useState(
    new Date(Date.UTC(2020, 11, 20, 3, 23, 16, 738))
  );
  const [isPickup, setIsPickup] = useState(true);
  const [tripInfo, setTripInfo] = useState({});
  const [paymentOptions, setPaymentOptions] = useState(null);
  const [walletToDebit, setWalletToDebit] = useState("");
  const [current, setCurrent] = React.useState(0);
  const [bnplAmount, setBnplAmount] = useState();
  const [bnplPublicKey, setBnplPublicKey] = useState("");
  const [bnplSignature, setBnplSignature] = useState("");

  // const [returnTripInfo, setReturnTripInfo] = useState({});
  // const paymentOptions = [
  //   // { id: 22, name: "woven" },
  //   { id: 25, name: "budPay" },
  //   { id: 8, name: "flutterwave" },
  //   { id: 5, name: "paystack" },
  //   { id: 26, name: "azaPay" },
  //   { id: 23, name: "wallet" },
  // ];
  // const userTripDetails = localStorage.getItem("allTripDetails");
  // const data = JSON.parse(userTripDetails);
  // let userSelectedSeat = localStorage.getItem("selectedSeats");
  // userSelectedSeat = JSON.parse(userSelectedSeat);

  let userInfo = localStorage.getItem("userSelect");
  userInfo = JSON.parse(userInfo);
  // let tripInfo = localStorage.getItem("selectedBusData");
  // tripInfo = JSON.parse(tripInfo);
  let returnTripInfo = localStorage.getItem("selectedReturnBusData");
  returnTripInfo = JSON.parse(returnTripInfo);
  const totalPayableAmount =
    returnTripInfo === null
      ? tripInfo?.farePrice * userInfo?.noOfAdult
      : // ? tripInfo?.FarePrice * userInfo?.noOfAdult
        returnTripInfo?.farePrice * userInfo?.noOfAdult +
        tripInfo?.farePrice * userInfo?.noOfAdult;
  let selectedSeats = localStorage.getItem("selectedSeats");
  selectedSeats = JSON.parse(selectedSeats);
  const userSeats = selectedSeats?.toString();
  let selectedSeatsReturn = localStorage.getItem("selectedSeatsReturn");
  selectedSeatsReturn =
    selectedSeatsReturn === null ? "1,2,3" : JSON.parse(selectedSeatsReturn);
  const userReturnSeats = selectedSeatsReturn?.toString();
  const routeDate = userInfo?.date ? new Date(userInfo?.date) : alternativeDate;
  const dateTimeFormat = new Intl.DateTimeFormat("en", {
    year: "numeric",
    month: "long",
    day: "numeric",
  });

  const onValueChange = (e) => {
    setGender(e.target.value);
  };

  const username = `${fullName} ${lastName}`;

  const { Step } = Steps;

  const steps = [
    {
      title: "Pick Up",
      content: (
        <section>
          <p className="step-p mt-3">Would you like to be picked up</p>
          <div className="stepform-card">
            <div className="stepform-card-sub">
              <div className="pick-up-card">
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="exampleCheck1"
                    name="pickup"
                    value="yes"
                    onChange={() => handlePickup()}
                  />
                  <label className="label-auth" htmlFor="exampleCheck1">
                    Yes, I want to be picked up.
                  </label>
                </div>
                <div className="form-check">
                  <input
                    type="radio"
                    className="form-check-input"
                    id="exampleCheck2"
                    name="pickup"
                    value="no"
                    onChange={() => setIsPickup(false)}
                  />
                  <label className="label-auth" htmlFor="exampleCheck2">
                    No, I will join the Bus at the terminal
                  </label>
                </div>
              </div>
              <div className="">
                <Button
                  text="Back"
                  handleButtonClick={() => history.push("/select-bus")}
                  type="button"
                  btnstyle={{
                    background: "transparent",
                    color: "red",
                    margin: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "24px",
                    border: "1px solid red",
                    width: "100px",
                  }}
                  // disabled={!fullName}
                />
                <Button
                  text="Proceed"
                  handleButtonClick={() => next()}
                  type="button"
                  btnstyle={{
                    background: "red",
                    color: "white",
                    margin: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "24px",
                    width: "100px",
                  }}
                  disabled={isPickup === true ? true : false}
                />
              </div>
            </div>
          </div>
        </section>
      ),
      // content: <LoanTypeInput loanTypeError={loanTypeError} next={next} />,
    },
    {
      title: "Passenger Details",
      content: (
        <section>
          <div className="stepform-card">
            <div className="stepform-card-sub">
              <p className="step-p">
                Please enter name as they appear on identification document
              </p>
              <div className="digicard">
                <img src={personaldetailscircle} alt="" /> &nbsp;
                <img
                  src={personaldetailslongcone}
                  alt=""
                  style={{ marginTop: "-12px" }}
                />
                <img
                  src={personaldetailsshortcone}
                  alt=""
                  style={{ marginTop: "-30px" }}
                />
              </div>
              {/* <h2 className="step-p">Adult 1</h2> */}
              <label className="label-auth">Full Name</label>
              <InputField
                type="text"
                placeholder="Enter Full Name"
                onChangeMethod={(e) => setFullName(e.target.value)}
                value={fullName}
                // readonly={loggedInUser === null ? false : true}
              />
              <br />
              <br />
              <label className="con1">
                <span>Male</span>
                <input
                  type="radio"
                  name="gender"
                  value="male"
                  checked={gender === "male"}
                  onChange={onValueChange}
                  disabled={loggedInUser === null ? false : true}
                />
                <span className="checkmarkSpan"></span>
              </label>
              <label className="con1">
                <span>Female</span>
                <input
                  type="radio"
                  name="gender"
                  value="female"
                  checked={gender === "female"}
                  onChange={onValueChange}
                  disabled={loggedInUser === null ? false : true}
                />
                <span className="checkmarkSpan"></span>
              </label>
              {userInfo?.noOfAdult == 1 ? null : (
                <>
                  {inputList?.map((el, index) => {
                    // return createInput(el, index);
                    const inputs = [];
                    inputs?.push(
                      <div className="stepform-card" key={index}>
                        <h2 className="step-p">Passenger #{index + 2}</h2>
                        <label className="label-auth">Full Name</label>
                        <input
                          type="text"
                          placeholder="Enter Full Name"
                          name="fullName"
                          value={el?.fullName}
                          onChange={(e) => handleInputChange(index, e)}
                          className="multiple-input"
                          required
                        />
                        <br />
                        <br />
                        <label className="con1">
                          <span>Male</span>
                          <input
                            type="radio"
                            name={`${index}-Gender`}
                            value="0"
                            onChange={(e) => handleInputChange(index, e)}
                            required
                          />
                          <span className="checkmarkSpan"></span>
                        </label>
                        <label className="con1">
                          <span>Female</span>
                          <input
                            type="radio"
                            name={`${index}-Gender`}
                            value="1"
                            onChange={(e) => handleInputChange(index, e)}
                            required
                          />
                          <span className="checkmarkSpan"></span>
                        </label>
                      </div>
                    );

                    return inputs;
                  })}
                </>
              )}
              <div className="">
                <Button
                  text="Back"
                  handleButtonClick={() => prev()}
                  type="button"
                  btnstyle={{
                    background: "transparent",
                    color: "red",
                    margin: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "24px",
                    border: "1px solid red",
                    width: "100px",
                  }}
                  // disabled={!fullName}
                />
                <Button
                  text="Proceed"
                  handleButtonClick={() => next()}
                  type="button"
                  btnstyle={{
                    background: "red",
                    color: "white",
                    margin: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "24px",
                    width: "100px",
                  }}
                  disabled={
                    userInfo?.noOfAdult == 1
                      ? !(fullName && gender)
                      : !(
                          fullName &&
                          gender &&
                          inputList &&
                          passengerTwo === true &&
                          beneficiaryNameSet === true
                        )
                  }
                />
              </div>
            </div>
          </div>
        </section>
      ),
      // content: <AmountInput next={next2} prev={() => prev()} />,
    },
    {
      title: "Next of Kin Details",
      content: (
        <section>
          <div className="stepform-card">
            <div className="stepform-card-sub">
              <p className="step-p">
                We need your contact details for booking confirmation
              </p>
              <div className="row row-grid">
                <div
                  className="col-md-6"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <label className="label-auth">Customer Email Address</label>
                  <InputField
                    type="email"
                    placeholder="Enter Customer Email"
                    onChangeMethod={(e) => setEmail(e.target.value)}
                    value={email}
                    required
                    // readonly={loggedInUser === null ? false : true}
                  />
                </div>
                <div
                  className="col-md-6"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <label className="label-auth">Customer Phone Number</label>
                  {/* <PhoneInput
                          placeholder="Enter Customer phone number"
                          country="NG"
                          value={valueTwo}
                          onChange={setValueTwo}
                        /> */}
                  <InputField
                    type="tel"
                    placeholder="Enter Customer Phone Number"
                    onChangeMethod={(e) => setValueTwo(e.target.value)}
                    value={valueTwo}
                    // readonly={loggedInUser === null ? false : true}
                  />
                </div>
              </div>
              <br />
              <div className="row row-grid">
                <div
                  className="col-md-6"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                  }}
                >
                  <label className="label-auth">Next of Kin Name</label>
                  <InputField
                    type="text"
                    placeholder="Enter Next of Kin Name"
                    onChangeMethod={(e) => setKinName(e.target.value)}
                    value={kinName}
                  />
                </div>
                <div className="col-md-6">
                  <label className="label-auth">
                    Next of Kin's Mobile Phone Number
                  </label>
                  {/* <PhoneInput
                          placeholder="Enter next of kin number"
                          country="NG"
                          value={value}
                          onChange={setValue}
                        /> */}
                  <InputField
                    type="tel"
                    placeholder="Enter Next of Kin Number"
                    onChangeMethod={(e) => setValue(e.target.value)}
                    value={value}
                  />
                </div>
              </div>
              <br />
              <section>
                <Link to="/terms" target="_blank">
                  <h1 className="step-h1">Terms and Condition</h1>
                </Link>
                <p className="step-p">
                  Please Note that GIGM does not have a refund policy, however
                  our tickets valid for a month from day of purchase and we have
                  a no refund policy. By proceeding to make payment, you agree
                  to the Terms and Conditions of GIGM.
                </p>
              </section>
              <div className="">
                <Button
                  text="Back"
                  handleButtonClick={() => prev()}
                  type="button"
                  btnstyle={{
                    background: "transparent",
                    color: "red",
                    margin: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "24px",
                    border: "1px solid red",
                    width: "100px",
                  }}
                  // disabled={!fullName}
                />
                <Button
                  text="Proceed"
                  handleButtonClick={() => {
                    if (valueTwo === value) {
                      Swal.fire({
                        showConfirmButton: false,
                        timer: 4000,
                        text: "Passenger and Next of Kin Phone No. should not be the same!!!",
                        icon: "error",
                      });
                    } else if (value.length < 11 || valueTwo.length < 11) {
                      Swal.fire({
                        showConfirmButton: false,
                        timer: 4000,
                        text: "Phone No. should not be less than 11 characters",
                        icon: "error",
                      });
                    } else if (value.length > 11 || valueTwo.length > 11) {
                      Swal.fire({
                        showConfirmButton: false,
                        timer: 4000,
                        text: "Phone No. should not be greater than 11 characters",
                        icon: "error",
                      });
                    } else {
                      setVisiblePayBooking(true);
                    }
                  }}
                  type="button"
                  btnstyle={{
                    background: "red",
                    color: "white",
                    margin: "20px",
                    fontWeight: "600",
                    fontSize: "16px",
                    lineHeight: "24px",
                    width: "100px",
                  }}
                  disabled={!(kinName && value && valueTwo && email)}
                />
              </div>
            </div>
          </div>
        </section>
      ),
      // content: <PersonalInput next={next3} prev={() => prev()} />,
    },
  ];

  const { token } = theme.useToken();

  const handlePickup = () => {
    setIsPickup(true);
    // alert("is picked up")
    setVisiblePickup(true);
  };

  const next = () => {
    setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const items = steps.map((item) => ({ key: item.title, title: item.title }));

  const contentStyle = {
    // lineHeight: "260px",
    textAlign: "center",
    color: token.colorTextTertiary,
    // backgroundColor: token.colorFillAlter,
    borderRadius: token.borderRadiusLG,
    // border: `1px dashed ${token.colorBorder}`,
    marginTop: 16,
  };

  const handleInputChange = (i, e) => {
    const values = [...inputList];
    if (e.target.name === "fullName") {
      values[i].fullName = e.target.value;
      if (i + 2 == userInfo?.noOfAdult) {
        setBeneficiaryNameSet(true);
      }
      // setEmailAmountt(true)
    } else {
      values[i].Gender = e.target.value;
      if (i + 2 == userInfo?.noOfAdult) {
        setPassengerTwo(true);
      }
    }

    setInputList(values);
  };

  const handleAddFields = (value) => {
    const values = [...inputList];
    for (let i = 0; i < value - 1; i++) {
      values?.push({ fullName: "", Gender: "" });
      setInputList(values);
    }
  };

  useEffect(() => {
    if (loggedInUser === null) {
      return false;
    } else {
      setValueTwo(loggedInUser?.PhoneNumber);
      setFullName(
        `${loggedInUser?.FirstName} ${
          loggedInUser?.LastName == null ? "" : loggedInUser?.LastName
        }`
      );
      setLastName(loggedInUser?.LastName == null ? "" : loggedInUser?.LastName);
      setEmail(loggedInUser?.Email);
      setGender(loggedInUser?.Gender === 0 ? "male" : "female");
      setKinName(loggedInUser?.NextOfKinName);
      setValue(loggedInUser?.NextOfKinPhone);
      getCurrentWallet();
    }
    // eslint-disable-next-line
  }, []);

  const onChangeOtp = (otpInput) => {
    setOtpInput(otpInput);
  };

  const getCurrentWallet = () => {
    requestWallet(
      apiroutes.GetWallet(loggedInUser?.PhoneNumber, loggedInUser?.Email),
      "get",
      null,
      walletDetails.access_token
    )
      .then((res) => {
        const data = {
          availableBalance: res.data?.Payload.AvailableBalance || "",
          blockedBalance: res.data?.Payload.BlockedBalance || "",
          email: res.data?.Payload.Email || "",
          hasPin: res.data?.Payload.HasPin,
          id: res.data?.Payload.Id,
          ledgerBalance: res.data?.Payload.LedgerBalance || "",
          phoneNumber: res.data?.Payload.HhoneNumber || "",
        };
        setUserWallet(data);
        setWalletState(res.data?.Payload?.HasPin == true ? true : false);
      })
      .catch((err) => {
        if (
          err.response === undefined ||
          err.response.data?.description === "Wallet does not exist"
        ) {
          setWalletState(false);
        }
        setWalletState(false);
      });
  };

  const getAllPaymentGateways = () => {
    requestPayment(apiroutes.GetAllPaymentGateways(), "get", null, userToken)
      .then((res) => {
        const allPaymentFiltered = res.data.data.userData?.filter(
          (payment) =>
            payment.status === true &&
            payment.gatewayName !== "FirstBank USSD" &&
            payment.gatewayName !== "UnionBank"
        );

        setPaymentOptions(allPaymentFiltered);
      })
      .catch((err) => {
        console.log(err.response);

        // setWalletState(false);
      });
  };
  const initiateCreditDirectRequest = (refCode, amount) => {
    setBnplAmount(amount);
    localStorage.setItem("initiateCreditDirectAmount", JSON.stringify(amount));
    requestBooking(
      apiroutes.InitiateCreditDirectRequest(refCode),
      "get",
      null,
      userToken
    )
      .then((res) => {
        // setBnplCustomerPhoneNumber(res.data?.data?.transaction?.customerPhoneNumber)
        setBnplPublicKey(res.data?.data?.publicKey);
        // setBnplSignature(res.data?.data?.signature)
        openCheckout(
          "24b56ca77f9033182e11ee2452be07173d7dd74512a1be25024296215a1fe6bd",
          res.data?.data?.publicKey
        );
        // openCheckout(res.data?.data?.signature, res.data?.data?.publicKey)

        // setPaymentOptions(allPaymentFiltered);
      })
      .catch((err) => {
        console.log(err.response);
      });
  };

  const checkEmail = () => {
    var filter =
      /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;

    if (!filter.test(email)) {
      setVisiblePayBooking(false);
      Swal.fire({
        showConfirmButton: false,
        timer: 4000,
        text: `Please provide a valid email address`,
        icon: "error",
      });
      return false;
    } else {
      setVisiblePayBooking(false);
      toggleModal();
    }
  };

  const toggleModal = () => {
    // if (valueTwo === value) {
    //   Swal.fire({
    //     showConfirmButton: false,
    //     timer: 4000,
    //     text: "Passenger and Next of Kin Phone No. should not be the same!!!",
    //     icon: "error",
    //   });
    // } else if (value.length < 11 || valueTwo.length < 11) {
    //   Swal.fire({
    //     showConfirmButton: false,
    //     timer: 4000,
    //     text: "Phone No. should not be less than 11 characters",
    //     icon: "error",
    //   });
    // } else if (value.length > 11 || valueTwo.length > 11) {
    //   Swal.fire({
    //     showConfirmButton: false,
    //     timer: 4000,
    //     text: "Phone No. should not be greater than 11 characters",
    //     icon: "error",
    //   });
    // } else {
    setVisible(true);
    // }
    // setLoading(true);
  };
  // const toggleModal = () => {
  //   if(!kinName && !value ) {
  //     alert("Please enter next of kin details")
  //   } else {
  //   setVisible(true);
  // }
  // };

  const toggleModalClose = () => {
    setVisible(false);
  };

  const toggleModalPin = () => {
    setVisiblePin(true);
    toggleModalClose();
  };

  const toggleModalPinClose = () => {
    setVisiblePin(false);
    history.push("/confirmed-wallet-payment");
  };
  const toggleModalPickupClose = () => {
    setVisiblePickup(false);
  };

  const toggleModalAmount = () => {
    setVisibleAmount(true);
    toggleModalClose();
  };

  const toggleModalAmountClose = () => {
    setVisibleAmount(false);
    // window.location.reload();
  };

  const toggleModalPayBooking = () => {
    setVisiblePayBooking(false);
  };

  const nf = new Intl.NumberFormat();

  const payPostSearch = (items) => {
    if (
      items.id === 1 &&
      cashbackWalletUser?.AccountBalance < totalPayableAmount
    ) {
      toggleModalAmount();
      return;
    }

    if (items.id === 2 && walletUser?.availableBalance < totalPayableAmount) {
      toggleModalAmount();
      return;
    }

    const tripInfoo = JSON.parse(localStorage.getItem("selectedBusData"));

    setPageLoading(true);
    let postData = {};
    if (data.tripType === 0) {
      if (userInfo?.noOfAdult === 1 || userInfo?.noOfAdult === "1") {
        postData = {
          tripType: 0,
          paymentMethod: items?.id,
          bookingType: 2,
          passengerType: 0,
          firstName: fullName,
          lastName: lastName,
          gender: gender === "male" ? 0 : 1,
          routeId: tripInfo?.routeId,
          onewayAmount: tripInfo?.farePrice,
          returnAmount: returnTripInfo?.farePrice,
          totalAmount: totalPayableAmount,
          travelDocumentId: 0,
          email: email,
          phoneNumber: valueTwo,
          nextOfKinName: kinName,
          nextOfKinPhone: value,
          seatRegistrations: `${tripInfo?.vehicleTripRegistrationId}:${userSeats}`,
          // seatRegistrations: tripInfo?.vehicleTripRegistrationId.concat(
          //   ":" + userSeats
          // ),
          vehicleTripRegistrationId: tripInfo?.vehicleTripRegistrationId,
          isSub: tripInfo?.isSub === true ? true : false,
        };
      } else {
        postData = {
          tripType: 0,
          paymentMethod: items?.id,
          bookingType: 2,
          passengerType: 0,
          firstName: fullName,
          lastName: lastName,
          gender: gender === "male" ? 0 : 1,
          routeId: tripInfo?.routeId,
          onewayAmount: tripInfo?.farePrice,
          returnAmount: returnTripInfo?.farePrice,
          totalAmount: totalPayableAmount,
          travelDocumentId: 0,
          email: email,
          phoneNumber: valueTwo,
          nextOfKinName: kinName,
          nextOfKinPhone: value,
          seatRegistrations: `${tripInfo?.vehicleTripRegistrationId}:${userSeats}`,
          vehicleTripRegistrationId: tripInfo?.vehicleTripRegistrationId,
          beneficiaries: inputList,
          isSub: tripInfo?.isSub === true ? true : false,
        };
      }
    } else {
      if (userInfo?.noOfAdult === 1 || userInfo?.noOfAdult === "1") {
        postData = {
          tripType: 1,
          paymentMethod: items?.id,
          bookingType: 2,
          passengerType: 0,
          firstName: fullName,
          lastName: lastName,
          gender: gender === "male" ? 0 : 1,
          routeId: tripInfo?.routeId,
          routeIdReturn: returnTripInfo?.routeId,
          onewayAmount: tripInfo?.farePrice,
          returnAmount: returnTripInfo?.farePrice,
          totalAmount: totalPayableAmount,
          travelDocumentId: 0,
          email: email,
          phoneNumber: valueTwo,
          nextOfKinName: kinName,
          nextOfKinPhone: value,
          seatRegistrations: `${tripInfo?.vehicleTripRegistrationId}:${userSeats}; ${returnTripInfo?.vehicleTripRegistrationId}:${userReturnSeats}`,
          // seatRegistrations:
          //   tripInfo?.vehicleTripRegistrationId?.concat(":" + userSeats) +
          //   ";" +
          //   returnTripInfo?.vehicleTripRegistrationId?.concat(
          //     ":" + userReturnSeats
          //   ),
          vehicleTripRegistrationId: tripInfo?.vehicleTripRegistrationId,
          isSub: tripInfo?.isSub === true ? true : false,
        };
      } else {
        postData = {
          tripType: 1,
          paymentMethod: items?.id,
          bookingType: 2,
          passengerType: 0,
          firstName: fullName,
          lastName: lastName,
          gender: gender === "male" ? 0 : 1,
          routeId: tripInfo?.routeId,
          routeIdReturn: returnTripInfo?.routeId,
          onewayAmount: tripInfo?.farePrice,
          returnAmount: returnTripInfo?.farePrice,
          totalAmount: totalPayableAmount,
          travelDocumentId: 0,
          email: email,
          phoneNumber: valueTwo,
          nextOfKinName: kinName,
          nextOfKinPhone: value,
          seatRegistrations: `${tripInfo?.vehicleTripRegistrationId}:${userSeats}; ${returnTripInfo?.vehicleTripRegistrationId}:${userReturnSeats}`,
          vehicleTripRegistrationId: tripInfo?.vehicleTripRegistrationId,
          beneficiaries: inputList,
          isSub: tripInfo?.isSub === true ? true : false,
        };
      }
    }

    requestBooking(apiroutes.PostSearch(), "post", postData, userToken)
      .then((res) => {
        // if (res.data.data === null) {
        // if (res.data.code !== 1 || res.data.code !== "1") {
        // alert("Seat(s) no Longer Available, Please select another seat.");
        //   Swal.fire({
        //     showConfirmButton: false,
        //     timer: 4000,
        //     // text: `${res.data?.Code}`,
        //     text: `${res.data?.shortDescription}`,
        //     icon: "error",
        //   });
        //   history.push("/select-bus");
        // }

        setPageLoading(false);

        const emailAmount = {
          email: email,
          amount: res.data?.data.amount,
          mainName: fullName,
          // mainName: username,
          otherNames: inputList,
          seats: selectedSeats,
          refCode: res.data.data?.bookingReferenceCode,
          phonenumber: valueTwo,
        };

        localStorage.setItem("transEmailAmount", JSON.stringify(emailAmount));
        if (items.id === 5) {
          setPageLoading(true);
          // history.push("/pay-paystack");
          // paystackPay(
          paystackNewPay(
            res.data.data?.bookingReferenceCode,
            res.data.data?.amount
          );
        } else if (items.id === 29) {
          setPageLoading(true);
          initiateCreditDirectRequest(
            res.data.data?.bookingReferenceCode,
            res.data.data?.amount
          );
          // openCheckout()
        } else if (items.id === 28) {
          setPageLoading(true);
          nombaPay(res.data.data?.bookingReferenceCode, res.data.data?.amount);
        } else if (items.id === 30) {
          setPageLoading(true);
          monnifyPay(
            res.data.data?.bookingReferenceCode,
            res.data.data?.amount
          );
        } else if (items.id === 8) {
          setPageLoading(true);
          history.push("/pay-flutter");

          // } else if (items.id === 22) {
          //   wovenPay(
          //     res.data.Object?.BookingReferenceCode,
          //     res.data.Object?.Amount
          //   );
        } else if (items.id === 25) {
          setPageLoading(true);
          history.push("/pay-budpay");
          // budPay(
          //   res.data.Object?.BookingReferenceCode,
          //   res.data.Object?.Amount
          // );

          // setTimeout(() => handleBudPayPayment(), 5000);
        } else if (items.id === 26) {
          azaPay(res.data.data?.bookingReferenceCode, res.data.data?.amount);
        } else if (items.id === 23) {
          walletPay(res.data.data?.amount, "23");
        } else if (items.id === 1) {
          walletPay(res.data.data?.amount, "1");
          // cashbackWalletPay(res.data.data?.amount);
        } else {
          return false;
        }
      })
      .catch((err) => {
        setPageLoading(false);
        Swal.fire({
          showConfirmButton: false,
          timer: 4000,
          // text: `${res.data?.Code}`,
          text: `${err?.response.data.shortDescription}`,
          icon: "error",
        });
        history.push("/select-bus");
        // alert(err.response);
      });
  };

  let connect;

  const transaction = {
    totalAmount:
      bnplAmount ||
      JSON.parse(localStorage.getItem("initiateCreditDirectAmount")),
    // totalAmount: bnplAmount,
    // totalAmount: parseInt(bnplAmount),
    customerEmail: email,
    customerPhone: valueTwo,
    sessionId: generateUniqueSessionId(15),
    products: [
      {
        productName: "GIGM Booking",
        productAmount:
          bnplAmount ||
          JSON.parse(localStorage.getItem("initiateCreditDirectAmount")),
        productId: "2",
      },
    ],
  };

  let configss = {
    publicKey: JSON.stringify(bnplPublicKey),
    signature:
      "24b56ca77f9033182e11ee2452be07173d7dd74512a1be25024296215a1fe6bd",
    // signature: JSON.stringify(bnplSignature),
    transaction: transaction,
    isLive: false,
    onSuccess: function (response) {
      /** 
        send this checkoutTransactionId back to your server to listen to 
         payout notification with webhook.
        */
      console.log(JSON.stringify(response));

      //  history.push("/bnpl-call-back");
    },
    onClose: function () {
      console.log("User closed checkout widget.");
      alert("Booking cancelled.");
      // history.push("/bnpl-call-back");
    },
    onPopup: function (response) {
      console.log(JSON.stringify(response));
    },
  };
  connect = new window.Connect(configss);
  connect.setup();

  function generateUniqueSessionId(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  }

  async function openCheckout(signature, publicKey) {
    transaction.sessionId = generateUniqueSessionId(15);
    configss.signature =
      "24b56ca77f9033182e11ee2452be07173d7dd74512a1be25024296215a1fe6bd";
    // config.signature = signature;
    configss.publicKey = publicKey;
    connect = new window.Connect(configss);
    connect.setup();
    connect.open();
  }

  const paystackPay = (refCode, amount) => {
    setPageLoading(true);
    const configLoad = {
      reference: refCode,
      email: email,
      amount: amount * 100,
      callback_url: process.env.REACT_APP_FALL_BACK_ENDPOINT,
      // callback_url: config.FALL_BACK_ENDPOINT,
      onClose: process.env.REACT_APP_FALL_BACK_ENDPOINT,
      // onClose: config.FALL_BACK_ENDPOINT,
    };
    return makeAPICall({
      payload: configLoad,
      method: "POST",
    })
      .then((result) => {
        if (result.status === true) {
          window.location.href = `https://checkout.paystack.com/${result.data.access_code}`;
        }
      })
      .catch((err) => {
        console.log(err);
        // alert(err);
        // alert(err.response.ShortDeescription)
      });
  };

  const payWallet = () => {
    toggleModalPinClose();
    setLoader(true);
    // setLoadingLoading(true);
    const data = JSON.parse(localStorage.getItem("transEmailAmount"));
    // const formEncoded = new URLSearchParams({
    //   Email: email,
    //   Amount: totalPayableAmount,
    //   // Amount: data.amount,
    //   PhoneNumber: valueTwo,
    //   WalletId: walletUser?.id,
    //   Reference: data?.refCode,
    //   TransactionDesc: "Bus Booking",
    //   Pin: otpInput,
    // });
    const walletPin = {
      Email: email,
      Amount: totalPayableAmount,
      PhoneNumber: valueTwo,
      WalletId: walletUser?.id,
      Reference: data?.refCode,
      TransactionDesc: "Bus Booking",
      Pin: otpInput,
      WalletToDebit: walletToDebit,
    };
    localStorage.setItem("walletPin", JSON.stringify(walletPin));
    setTimeout(() => history.push("/confirmed-wallet-payment"), 1500);
    // requestWallet(
    //   apiroutes.DebitWallet(),
    //   "post",
    //   formEncoded,
    //   walletDetails.access_token
    // )
    //   .then((res) => {
    //     if (res.data.description === "Successful") {
    //       history.push("/confirmed-wallet-payment");
    //     }
    //   })
    //   .catch((err) => {
    //     // alert(err.response.data.description)
    //     Swal.fire({
    //       showConfirmButton: false,
    //       timer: 4000,
    //       text: err.response.data.description,
    //       icon: "error",
    //     });
    //     setTimeout(() => {history.push("/confirmed-wallet-payment")}, 2000)
    //   });
  };

  const walletPay = (amount, walletTypeToDebit) => {
    // if (walletUser?.availableBalance < amount) {
    //   toggleModalAmount();
    // } else {
    setWalletToDebit(walletTypeToDebit);
    toggleModalPin();
    // payWallet(refCode, amount);
    // }
  };
  const cashbackWalletPay = (amount) => {
    if (cashbackWalletUser?.AccountBalance < amount) {
      toggleModalAmount();
    } else {
      setWalletToDebit("cashback");
      toggleModalPin();
      // payWallet(refCode, amount);
    }
  };
  // const walletPay = (items) => {
  //   if (walletUser.availableBalance < totalPayableAmount) {
  //     toggleModalAmount();
  //   } else {
  //     // payPostSearch(items);
  //     toggleModalPin()
  //     // toggleModalPin();
  //     // payWallet(refCode, amount);
  //   }
  // };

  const azaPay = (refCode, amount) => {
    const configLoad = {
      customerEmail: email,
      customerName: fullName,
      customerPhone: valueTwo,
      ref: refCode,
      amount: JSON.stringify(amount),
    };
    localStorage.setItem("azaPayload", JSON.stringify(configLoad));
    return makeAPICallAzaPay({
      Payload: configLoad,
      method: "POST",
    })
      .then((result) => {
        if (result.status === 200) {
          localStorage.setItem(
            "azaPayAccountDetails",
            JSON.stringify(result.data)
          );
          history.push("/aza-pay");
          // window.location.href = result.data.authorization_url;
        }
      })
      .catch((err) => console.log(err));
  };

  const budPay = (refCode, amount) => {
    const configLoad = {
      email: email,
      reference: refCode,
      amount: JSON.stringify(amount),
      // currency: "NGN",
      callback: config.FALL_BACK_ENDPOINT_BUDPAY,
      // payment_options: "card, mobilemoney, ussd",
      // customer: {
      //   email: email,
      //   phonenumber: valueTwo,
      // },
    };
    return makeAPICallBudPay({
      Payload: configLoad,
      method: "POST",
    })
      .then((result) => {
        if (result.status === true) {
          window.location.href = result.data.authorization_url;
        }
      })
      .catch((err) => console.log(err));
  };

  const monnifyPay = (refCode, amount) => {
    const configLoad = {
      reference: refCode,
      amount: JSON.stringify(amount),
      customerName: fullName,
      customerEmail: email,
      paymentReference: refCode,
      paymentDescription: "WEB",
      currencyCode: "NGN",
      contractCode: "5136745845",
      redirectUrl: config.FALL_BACK_ENDPOINT_MONIEPOINT,
      paymentMethods: [""],
    };

    requestPayment(
      apiroutes.InitiateMoniePointRequest(),
      "post",
      configLoad,
      userToken
    )
      .then((res) => {
        // console.log(res, "NUGAGEE EEEEE");
        if (res?.data?.code == 1) {
          // setPageLoading(false);
          if (res?.data.data?.requestSuccessful === true) {
            window.location.href = res.data?.data?.responseBody?.checkoutUrl;
          }
        } else {
          // setLoading(false);
          // setErrorMessage(res.data.shortDescription);
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `${res.data.shortDescription}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        // setLoading(false);
        Swal.fire({
          showConfirmButton: false,
          timer: 4000,
          text: `Error while processing your request.`,
          icon: "error",
        });
        // setTimeout(() => window.location.reload(), 1500);
      });
  };
  const paystackNewPay = (refCode, amount) => {
    const configLoad = {
      amount: amount * 100,
      email,
      reference: refCode,
      countrycode: "NG",
      callback_url: "https://gigm.com/call-back",
      // callback_url: config.FALL_BACK_ENDPOINT,
    };

    requestPayment(
      apiroutes.InitiatePaystackNewPayRequest(),
      "post",
      configLoad,
      userToken
    )
      .then((res) => {
        // console.log(res, "NUGAGEE EEEEE");
        if (res?.data?.code == 1) {
          // setPageLoading(false);
          window.location.href = res.data?.data;
        } else {
          // setLoading(false);
          // setErrorMessage(res.data.shortDescription);
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `${res.data.shortDescription}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        // setLoading(false);
        Swal.fire({
          showConfirmButton: false,
          timer: 4000,
          text: `Error while processing your request.`,
          icon: "error",
        });
        // setTimeout(() => window.location.reload(), 1500);
      });
  };
  const nombaPay = (refCode, amount) => {
    const configLoad = {
      order: {
        orderReference: refCode,
        amount: JSON.stringify(amount),
        // callbackUrl: "http://localhost:3000/nomba-pay",
        callbackUrl: config.FALL_BACK_ENDPOINT_NOMBA,
        customerId: email,
        customerEmail: email,
        currency: "NGN",
      },
      tokenizeCard: true,
    };

    requestPayment(
      apiroutes.InitiateNombaRequest(),
      "post",
      configLoad,
      userToken
    )
      .then((res) => {
        console.log(res, "NUGAGEE EEEEE");
        if (res?.data?.code == 1) {
          // setPageLoading(false);
          // if (res?.data.data?.requestSuccessful === true) {
          window.location.href = res.data?.data?.data?.checkoutLink;
          // }
        } else {
          // setLoading(false);
          // setErrorMessage(res.data.shortDescription);
          Swal.fire({
            showConfirmButton: false,
            timer: 4000,
            text: `${res.data.shortDescription}`,
            icon: "error",
          });
        }
      })
      .catch((err) => {
        // setLoading(false);
        Swal.fire({
          showConfirmButton: false,
          timer: 4000,
          text: `Error while processing your request.`,
          icon: "error",
        });
        // setTimeout(() => window.location.reload(), 1500);
      });
  };

  // const flutterPay = (refCode, amount) => {
  // return console.log("flutterwave pay");
  // const configLoad = {
  //   tx_ref: refCode,
  //   amount: amount,
  //   currency: "NGN",
  //   redirect_url: config.FALL_BACK_ENDPOINT_FLUTTER,
  //   payment_options: "card, mobilemoney, ussd",
  //   customer: {
  //     email: email,
  //     phonenumber: valueTwo,
  //   },
  // };
  // return makeAPICallFlutter({
  //   Payload: configLoad,
  //   method: "POST",
  // })
  //   .then((result) => {
  //     if (result.status === "success") {
  //       window.location.href = result.data.link;
  //     }
  //   })
  //   .catch((err) => console.log(err));
  // };

  const currentNow = new Date();

  // eslint-disable-next-line no-extend-native
  Date.prototype.addMinutes = function (minutes) {
    this.setMinutes(this.getMinutes() + minutes);
    return this;
  };

  // const wovenPay = (refCode, amount) => {
  //   const configLoad = {
  //     customer_reference: refCode,
  //     name: fullName,
  //     email: email,
  //     mobile_number: valueTwo,
  //     expires_on: currentNow.addMinutes(60).toString("yyyy-MM-dd : HH:MM:ss"),
  //     use_frequency: "1",
  //     min_amount: amount,
  //     max_amount: amount,
  //     callback_url: config.FALL_BACK_ENDPOINT_WOVEN,
  //     destination_nuban: "",
  //     // meta_data: ["somedatakey", "somdatavalue"],
  //   };
  //   setLoader(false);
  //   return makeAPICallWoven({
  //     Payload: configLoad,
  //     method: "POST",
  //   })
  //     .then((result) => {
  //       setLoader(true);
  //       localStorage.setItem(
  //         "wovenAccountDetails",
  //         JSON.stringify(result.data)
  //       );
  //       history.push("/woven-pay");
  //     })
  //     .catch((err) => console.log(err));
  // };

  const toggleModalPopupClose = () => {
    setVisiblePopup(false);
  };

  const widthPay = 470;
  const width = 500;
  const height = 530;
  const height2 = 500;
  const heightThree = 300;
  const modalTitle = "Trip payment";
  const modalPar = "You are about to fund this trip";
  const modalTitleTwo = "Transaction Pin";
  const modalParTwo = "Please Enter Your 4 Digit Transaction Pin";
  const modalBodyPin = (
    <div>
      <div className="row">
        <div className="col-md-12">
          <ButtonComponent
            secret
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
            inputStyle={{
              borderRadius: "0.7142857143rem",
              width: "60px",
              height: "60px",
              backgroundColor: "#f8f5f4",
              border: "0.3px solid #c5afad52",
              fontSize: "1.1428571429rem",
              fontFamily: "Cerebri Sans Pro Bold",
              color: "#949494",
              marginBottom: "10px",
            }}
            handlePincomplete={onChangeOtp}
            length={4}
          />
        </div>
      </div>
      <br />
      <div className="row">
        <div className="col-sm-12 col-md-8 offset-md-2">
          <div className="text-center">
            <Button
              type="button"
              handleButtonClick={payWallet}
              text="Proceed"
              disabled={!otpInput}
            />
          </div>
        </div>
      </div>
    </div>
  );

  const modalBodyLowAmount = (
    <div className="row">
      <div className="col-md-12">
        <div className="text-center">
          <img src={errorIcon} alt="" />
        </div>
        <p className="wallet-onboarding-p text-center">
          Your wallet balance is low
        </p>
        <br />
        {/* <div className="row"> */}
        <div className="col-sm-12 col-md-8 offset-md-2">
          <div className="text-center">
            <Button
              type="button"
              handleButtonClick={toggleModalAmountClose}
              text="Try Again"
            />
          </div>
        </div>
        {/* </div> */}
      </div>
    </div>
  );

  const modalBody = (
    <div>
      <div className="text-center">
        <p className="passenger-amt">Amount</p>
        <h1 className="p-amt">₦{nf.format(totalPayableAmount)}</h1>
        <p className="p-nb">
          <img src={nb} alt="" style={{ width: "10px" }} /> Selecting any of the
          payment method will redirect you to their payment platform.
        </p>
        <h2 className="pay-mthod">Select payment method</h2>
      </div>
      <br />
      <div className="row">
        <div className="col-sm-12">
          {pageLoading ? (
            <div className="text-center">
              <div className="lds-default">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          ) : (
            <div className="row">
              {paymentOptions?.map((items) => (
                <div className="col-md-6" key={items.id}>
                  <div onClick={() => payPostSearch(items)}>
                    <div>
                      {items.id === 5 ? (
                        <div className="pay-bg">
                          <img src={paystack} alt="" width="80px" />
                        </div>
                      ) : items.id === 28 ? (
                        <div className="pay-bg">
                          {/* <img src={nombaLogo} alt="" width="100px" /> */}
                          <svg
                            width="986"
                            height="472"
                            viewBox="0 0 986 472"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <rect
                              width="986"
                              height="472"
                              rx="20"
                              fill="#FFCC00"
                            />
                            <path
                              d="M433.235 241.873V296.862H413.499V246.455C413.499 233.472 406.668 226.598 395.282 226.598C383.896 226.598 375.547 234.236 375.547 247.983V296.098H355.811V210.56H373.269L375.547 221.252C381.619 212.851 391.486 208.269 403.631 208.269C420.331 208.269 433.235 222.016 433.235 241.873Z"
                              fill="#121212"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M449.175 253.329C449.175 227.362 469.669 207.505 495.477 207.505C521.285 207.505 541.78 226.598 541.78 252.565C541.78 278.532 520.526 298.389 495.477 298.389C469.669 298.389 449.175 279.296 449.175 253.329ZM495.477 225.835C510.658 225.835 522.045 237.29 522.045 253.329C522.045 269.367 510.658 280.823 495.477 280.823C480.296 280.823 468.911 269.367 468.911 253.329C468.911 237.29 480.296 225.835 495.477 225.835Z"
                              fill="#121212"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M278.712 215.403C278.91 215.159 279.106 214.914 279.301 214.667C279.058 214.787 278.819 214.905 278.583 215.019L278.712 215.403Z"
                              fill="#111111"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M121.639 240.693C116.013 211.426 144.144 115.022 161.603 111.641C128.959 158.699 147.071 201.249 160.208 216.642C183.7 251.977 245.028 257.061 278.712 215.403C280.07 219.437 281.078 223.037 281.649 226.06C284.439 240.853 283.053 289.429 281.868 330.934C281.2 354.34 280.596 375.497 280.841 387.079C280.942 392.478 276.754 397.019 271.355 397.246C266.893 397.446 261.837 397.858 256.688 398.277C246.871 399.076 236.717 399.903 229.7 399.34C224.679 398.937 220.869 394.673 220.995 389.652C221.222 380.594 219.481 364.851 218.775 359.124C202.221 362.285 201.576 362.213 187.834 360.661C186.224 360.479 184.434 360.277 182.418 360.057C181.854 365.781 182.145 372.082 182.428 378.223C182.589 381.691 182.746 385.107 182.746 388.34C182.746 393.437 179.29 397.953 174.319 399.189C163.218 401.99 145.204 400.047 133.194 396.565C129.864 395.581 127.215 393.058 126.105 389.778C116.719 361.672 114.322 264.763 121.639 240.693Z"
                              fill="#111111"
                            />
                            <path
                              d="M221.399 104.45C200.206 97.9158 161.578 111.641 161.578 111.641H161.603C128.959 158.699 147.071 201.249 160.208 216.642C183.7 251.977 245.028 257.061 278.712 215.403L278.583 215.019C266.026 178.06 224.753 105.493 221.399 104.45Z"
                              fill="#111111"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M320.147 331.046C321.86 318.88 293.585 248.731 280.44 233.341H280.415L245.772 244.683L275.546 314.784C275.546 314.784 282.606 338.554 291.042 344.73C291.111 344.78 291.172 344.83 291.236 344.887C291.9 345.484 296.029 349.021 299.648 348.18C308.281 346.402 320.667 340.376 320.147 331.046Z"
                              fill="#111111"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M284.776 206.583C282.985 209.56 280.891 212.512 278.544 215.337C278.192 215.762 277.834 216.184 277.47 216.604C278.003 215.97 278.528 215.324 279.048 214.668C272.168 218.078 267.912 219.22 260.9 218.57C258.567 218.353 256.199 218.77 254.144 219.895C212.609 242.641 179.072 240.417 159.955 216.642C160.182 216.985 160.414 217.324 160.648 217.661C146.164 199.299 142.94 176.431 144.093 168.031C146.111 153.524 157.969 116.36 161.325 111.642C164.68 106.923 216.402 96.2007 216.402 96.2007C224.451 112.323 252.456 147.872 278.872 157.333C296.432 163.616 297.189 186.171 284.776 206.583Z"
                              fill="white"
                            />
                            <path
                              d="M177.329 170.203C208.879 166.436 162.302 256.235 250.467 202.096C251.58 201.412 252.843 200.791 254.135 200.596C261.738 199.447 278.393 201.426 284.449 205.752C276.234 204.646 257.394 203.607 253.64 205.752C247.005 209.544 195.814 248.411 187.283 205.278C183.491 191.059 192.023 174.469 177.329 170.203Z"
                              fill="black"
                            />
                            <path
                              d="M289.189 196.746C291.085 186.319 302.935 164.99 270.704 153.614C287.293 157.88 304.357 168.307 289.189 196.746Z"
                              fill="black"
                            />
                            <path
                              d="M168.41 107.81C172.63 105.374 173.329 98.6855 169.972 92.8707C166.615 87.0558 160.473 84.3169 156.253 86.753C152.033 89.1892 151.334 95.8779 154.692 101.693C158.049 107.508 164.191 110.247 168.41 107.81Z"
                              fill="#111111"
                            />
                            <path
                              d="M213.91 96.4681C209.69 94.032 208.991 87.3432 212.348 81.5284C215.706 75.7135 221.848 72.9746 226.067 75.4107C230.287 77.8469 230.986 84.5356 227.629 90.3505C224.272 96.1653 218.129 98.9043 213.91 96.4681Z"
                              fill="#111111"
                            />
                            <path
                              d="M237.468 123.482C229.851 119.166 212.617 105.073 213.766 90.6048C220.064 102.726 237.468 123.482 237.468 123.482Z"
                              fill="#111111"
                            />
                            <path
                              d="M177.703 140.183C182.285 145.489 188.858 147.456 192.385 144.576C195.911 141.697 195.055 135.062 190.473 129.756C185.891 124.45 179.318 122.483 175.792 125.363C172.265 128.242 173.121 134.877 177.703 140.183Z"
                              fill="white"
                            />
                            <path
                              d="M180.168 138.484C183.174 141.813 187.405 142.978 189.62 141.087C191.835 139.196 191.194 134.964 188.189 131.635C185.184 128.306 180.952 127.141 178.737 129.032C176.522 130.923 177.163 135.155 180.168 138.484Z"
                              fill="#111111"
                            />
                            <path
                              d="M178.967 135.002C179.742 135.862 181.012 136.011 181.802 135.336C182.592 134.661 182.604 133.418 181.829 132.558C181.053 131.699 179.783 131.55 178.993 132.225C178.203 132.899 178.191 134.143 178.967 135.002Z"
                              fill="white"
                            />
                            <path
                              d="M230.525 134.225C234.003 140.312 240.077 143.504 244.09 141.355C248.104 139.207 248.538 132.53 245.059 126.444C241.581 120.357 235.508 117.164 231.495 119.313C227.481 121.462 227.047 128.138 230.525 134.225Z"
                              fill="white"
                            />
                            <path
                              d="M233.143 132.823C235.368 136.717 239.254 138.759 241.821 137.384C244.389 136.01 244.666 131.739 242.441 127.845C240.216 123.951 236.331 121.909 233.763 123.283C231.196 124.658 230.918 128.929 233.143 132.823Z"
                              fill="#111111"
                            />
                            <path
                              d="M232.713 129.166C233.288 130.171 234.496 130.588 235.412 130.097C236.329 129.607 236.606 128.394 236.031 127.389C235.457 126.384 234.249 125.967 233.333 126.458C232.416 126.948 232.139 128.161 232.713 129.166Z"
                              fill="white"
                            />
                            <path
                              d="M239.665 182.159C241.426 180.146 240.218 176.208 236.967 173.364C233.716 170.52 229.653 169.846 227.892 171.859C226.131 173.872 227.339 177.81 230.59 180.654C233.841 183.498 237.904 184.172 239.665 182.159Z"
                              fill="#FF5500"
                            />
                            <path
                              d="M267.437 177.083C264.975 176.038 264.347 171.967 266.035 167.991C267.723 164.015 271.087 161.639 273.549 162.684C276.011 163.729 276.638 167.799 274.95 171.776C273.263 175.752 269.899 178.128 267.437 177.083Z"
                              fill="#FF5500"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M81.0744 331.046C79.3614 318.88 107.636 248.731 120.781 233.341H120.806L155.449 244.683L125.675 314.784C125.675 314.784 118.615 338.554 110.179 344.73C110.11 344.78 110.049 344.83 109.985 344.887C109.321 345.484 105.192 349.021 101.573 348.18C92.9399 346.402 80.5541 340.376 81.0744 331.046Z"
                              fill="#111111"
                            />
                            <path
                              d="M204.282 292.491L199.513 295.237L204.282 297.983L209.05 300.753L213.819 303.523L218.612 306.268L223.381 309.014V320.045L218.612 317.299L213.819 314.529L209.05 311.784L204.282 309.014L199.513 306.268V311.784L194.744 314.529L189.951 317.299L185.182 320.045L180.413 322.815L175.62 325.56V314.529L180.413 311.784L185.182 309.014L189.951 306.268L194.744 303.523L199.513 300.753L194.744 297.983L189.951 295.237L185.182 292.491L180.413 289.722L175.62 286.976V275.945L180.413 278.691L185.182 281.46L189.951 284.206L194.744 286.976L199.513 289.722V284.206L204.282 281.46L209.05 278.691L213.819 275.945L218.612 273.199V273.175L223.381 270.429V281.46L218.612 284.206L213.819 286.976L209.05 289.722L204.282 292.467V292.491Z"
                              fill="#FFCC00"
                            />
                            <path
                              d="M687.521 296.862V241.109C687.521 221.252 674.617 208.269 657.159 208.269C644.254 208.269 633.626 215.142 628.314 225.071C623.757 214.379 613.892 208.269 602.505 208.269C591.877 208.269 582.769 213.615 576.697 221.252L574.42 210.56H557.72V296.862H577.456V247.983C577.456 234.236 585.047 226.598 595.671 226.598C605.54 226.598 612.374 233.472 612.374 246.455V296.862H632.108V247.983C632.108 234.236 639.697 226.598 650.325 226.598C660.194 226.598 667.024 233.472 667.024 246.455V296.862H687.521Z"
                              fill="#121212"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M802.137 253.329C802.137 280.059 782.402 298.389 758.87 298.389C745.965 298.389 735.341 293.043 727.749 283.878L725.472 296.862H708.014V174.665L727.749 172.374V222.78C734.582 213.615 745.206 209.033 758.111 209.033C783.161 208.269 802.137 226.598 802.137 253.329ZM756.593 225.835C771.016 225.835 782.402 237.29 782.402 253.329C782.402 269.367 771.016 280.823 756.593 280.823C742.171 280.823 730.025 269.367 730.025 253.329C730.025 237.29 742.171 225.835 756.593 225.835Z"
                              fill="#121212"
                            />
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M887.912 210.56H905.369V296.862H887.912L885.635 283.878C878.801 293.806 867.414 299.153 854.514 299.153C830.981 299.153 812.006 280.823 812.006 254.093C812.006 227.362 830.981 209.032 855.273 209.032C868.178 209.032 878.801 214.379 886.394 223.543L887.912 210.56ZM858.308 225.835C872.731 225.835 884.876 237.29 884.876 253.329C884.876 269.367 872.731 280.823 858.308 280.823C843.886 280.823 832.499 269.367 832.499 253.329C832.499 237.29 843.886 225.835 858.308 225.835Z"
                              fill="#121212"
                            />
                          </svg>
                          {/* <svg
                            class="w-[84px] "
                            width="160"
                            height="41"
                            viewBox="0 0 174 41"
                            fill="none"
                          >
                            <path
                              d="M65.1187 16.1888V28.8584H60.5674V17.2446C60.5674 14.2532 58.992 12.6695 56.3662 12.6695C53.7404 12.6695 51.8149 14.4292 51.8149 17.5966V28.6824H47.2636V8.97425H51.2897L51.8149 11.4378C53.2153 9.50215 55.4909 8.44635 58.2917 8.44635C62.1429 8.44635 65.1187 11.6137 65.1187 16.1888ZM68.7948 18.8283C68.7948 12.8455 73.5211 8.27039 79.4728 8.27039C85.4245 8.27039 90.1509 12.6695 90.1509 18.6524C90.1509 24.6352 85.2495 29.2103 79.4728 29.2103C73.5211 29.2103 68.7948 24.8112 68.7948 18.8283ZM85.5996 18.8283C85.5996 15.133 82.9738 12.4936 79.4728 12.4936C75.9718 12.4936 73.3461 15.133 73.3461 18.8283C73.3461 22.5236 75.9718 25.1631 79.4728 25.1631C82.9738 25.1631 85.5996 22.5236 85.5996 18.8283ZM123.761 16.0129V28.8584H119.034V17.2446C119.034 14.2532 117.459 12.6695 115.183 12.6695C112.732 12.6695 110.982 14.4292 110.982 17.5966V28.8584H106.431V17.2446C106.431 14.2532 104.855 12.6695 102.579 12.6695C100.129 12.6695 98.3783 14.4292 98.3783 17.5966V28.8584H93.827V8.97425H97.6781L98.2032 11.4378C99.6036 9.67811 101.704 8.44635 104.155 8.44635C106.781 8.44635 109.056 9.85408 110.107 12.3176C111.332 10.03 113.783 8.44635 116.759 8.44635C120.785 8.44635 123.761 11.4378 123.761 16.0129ZM150.193 18.8283C150.193 24.9871 145.642 29.2103 140.215 29.2103C137.239 29.2103 134.789 27.9785 133.038 25.867L132.513 28.8584H128.487V0.703865L133.038 0.17597V11.7897C134.614 9.67811 137.064 8.62232 140.04 8.62232C145.817 8.44635 150.193 12.6695 150.193 18.8283ZM145.642 18.8283C145.642 15.133 143.016 12.4936 139.69 12.4936C136.364 12.4936 133.563 15.133 133.563 18.8283C133.563 22.5236 136.364 25.1631 139.69 25.1631C143.016 25.1631 145.642 22.5236 145.642 18.8283ZM169.974 8.97425H174V28.8584H169.974L169.449 25.867C167.873 28.1545 165.247 29.3863 162.272 29.3863C156.845 29.3863 152.469 25.1631 152.469 19.0043C152.469 12.8455 156.845 8.62232 162.447 8.62232C165.423 8.62232 167.873 9.85408 169.624 11.9657L169.974 8.97425ZM169.274 18.8283C169.274 15.133 166.473 12.4936 163.147 12.4936C159.821 12.4936 157.195 15.133 157.195 18.8283C157.195 22.5236 159.821 25.1631 163.147 25.1631C166.473 25.1631 169.274 22.5236 169.274 18.8283ZM21.1811 16.5408L24.6821 14.4292L28.1831 12.3176L31.6841 10.206L35.1851 8.09442V0L31.6841 2.11159L28.1831 4.22318L24.6821 6.33477L21.1811 8.44635L17.6801 10.5579V14.6051L14.1791 12.4936L10.6781 10.382L7.00201 8.27039L3.50101 6.1588L0 4.04721V12.1416L3.50101 14.2532L7.00201 16.3648L10.503 18.4764L14.004 20.588L17.505 22.6996L14.004 24.8112L10.503 26.9227L7.00201 29.0343L3.50101 31.1459L0 32.9056V41L3.50101 38.8884L7.00201 36.7768L10.503 34.6652L14.004 32.5537L17.505 30.4421V26.3948L21.006 28.5064L24.507 30.618L28.008 32.7296L31.5091 34.8412L35.0101 36.9528V28.8584L31.5091 26.7468L28.008 24.6352L24.507 22.5236L21.006 20.412L17.505 18.3004L21.1811 16.5408Z"
                              fill="#121212"
                            ></path>
                          </svg> */}
                        </div>
                      ) : items.id === 29 ? (
                        <div className="pay-bg-wallet">
                          <img src={wallet} alt="" width="50px" />{" "}
                          <h4 className="ml-2 mt-1">
                            <b>BNPL</b>
                          </h4>
                        </div>
                      ) : items.id === 30 ? (
                        <div className="pay-bg-wallet">
                          {/* <img src={wallet} alt="" width="50px" />{" "} */}
                          <h4 className="ml-2 mt-1">
                            <b>Monnify Pay</b>
                          </h4>
                        </div>
                      ) : items.id === 8 ? (
                        // ) : items.id === 25 ? (
                        <div className="pay-bg">
                          <img src={flutterwave} alt="" width="100px" />
                        </div>
                      ) : items.id === 28 ? (
                        <div className="pay-bg">
                          <svg
                            class="w-[84px] "
                            width="160"
                            height="41"
                            viewBox="0 0 174 41"
                            fill="none"
                          >
                            <path
                              d="M65.1187 16.1888V28.8584H60.5674V17.2446C60.5674 14.2532 58.992 12.6695 56.3662 12.6695C53.7404 12.6695 51.8149 14.4292 51.8149 17.5966V28.6824H47.2636V8.97425H51.2897L51.8149 11.4378C53.2153 9.50215 55.4909 8.44635 58.2917 8.44635C62.1429 8.44635 65.1187 11.6137 65.1187 16.1888ZM68.7948 18.8283C68.7948 12.8455 73.5211 8.27039 79.4728 8.27039C85.4245 8.27039 90.1509 12.6695 90.1509 18.6524C90.1509 24.6352 85.2495 29.2103 79.4728 29.2103C73.5211 29.2103 68.7948 24.8112 68.7948 18.8283ZM85.5996 18.8283C85.5996 15.133 82.9738 12.4936 79.4728 12.4936C75.9718 12.4936 73.3461 15.133 73.3461 18.8283C73.3461 22.5236 75.9718 25.1631 79.4728 25.1631C82.9738 25.1631 85.5996 22.5236 85.5996 18.8283ZM123.761 16.0129V28.8584H119.034V17.2446C119.034 14.2532 117.459 12.6695 115.183 12.6695C112.732 12.6695 110.982 14.4292 110.982 17.5966V28.8584H106.431V17.2446C106.431 14.2532 104.855 12.6695 102.579 12.6695C100.129 12.6695 98.3783 14.4292 98.3783 17.5966V28.8584H93.827V8.97425H97.6781L98.2032 11.4378C99.6036 9.67811 101.704 8.44635 104.155 8.44635C106.781 8.44635 109.056 9.85408 110.107 12.3176C111.332 10.03 113.783 8.44635 116.759 8.44635C120.785 8.44635 123.761 11.4378 123.761 16.0129ZM150.193 18.8283C150.193 24.9871 145.642 29.2103 140.215 29.2103C137.239 29.2103 134.789 27.9785 133.038 25.867L132.513 28.8584H128.487V0.703865L133.038 0.17597V11.7897C134.614 9.67811 137.064 8.62232 140.04 8.62232C145.817 8.44635 150.193 12.6695 150.193 18.8283ZM145.642 18.8283C145.642 15.133 143.016 12.4936 139.69 12.4936C136.364 12.4936 133.563 15.133 133.563 18.8283C133.563 22.5236 136.364 25.1631 139.69 25.1631C143.016 25.1631 145.642 22.5236 145.642 18.8283ZM169.974 8.97425H174V28.8584H169.974L169.449 25.867C167.873 28.1545 165.247 29.3863 162.272 29.3863C156.845 29.3863 152.469 25.1631 152.469 19.0043C152.469 12.8455 156.845 8.62232 162.447 8.62232C165.423 8.62232 167.873 9.85408 169.624 11.9657L169.974 8.97425ZM169.274 18.8283C169.274 15.133 166.473 12.4936 163.147 12.4936C159.821 12.4936 157.195 15.133 157.195 18.8283C157.195 22.5236 159.821 25.1631 163.147 25.1631C166.473 25.1631 169.274 22.5236 169.274 18.8283ZM21.1811 16.5408L24.6821 14.4292L28.1831 12.3176L31.6841 10.206L35.1851 8.09442V0L31.6841 2.11159L28.1831 4.22318L24.6821 6.33477L21.1811 8.44635L17.6801 10.5579V14.6051L14.1791 12.4936L10.6781 10.382L7.00201 8.27039L3.50101 6.1588L0 4.04721V12.1416L3.50101 14.2532L7.00201 16.3648L10.503 18.4764L14.004 20.588L17.505 22.6996L14.004 24.8112L10.503 26.9227L7.00201 29.0343L3.50101 31.1459L0 32.9056V41L3.50101 38.8884L7.00201 36.7768L10.503 34.6652L14.004 32.5537L17.505 30.4421V26.3948L21.006 28.5064L24.507 30.618L28.008 32.7296L31.5091 34.8412L35.0101 36.9528V28.8584L31.5091 26.7468L28.008 24.6352L24.507 22.5236L21.006 20.412L17.505 18.3004L21.1811 16.5408Z"
                              fill="#121212"
                            ></path>
                          </svg>
                        </div>
                      ) : //  items.id === 25 ? (
                      // ) : items.id === 22 ? (
                      //   <div className="pay-bg">
                      //     <img src={woven} alt="" width="100px" />
                      //   </div>
                      items.id === 25 ? (
                        <div className="pay-bg">
                          <img src={budPayImg} alt="" width="100px" />
                        </div>
                      ) : items.id === 26 ? (
                        <div className="pay-bg">
                          <img src={azaPayLogo} alt="" width="100px" />
                        </div>
                      ) : items.id === 23 ? (
                        walletState && (
                          <div className="pay-bg-wallet">
                            <img src={wallet} alt="" width="50px" />{" "}
                            <h4 className="ml-2 mt-1">
                              <b>Wallet</b>
                            </h4>
                          </div>
                        )
                      ) : items.id === 1 ? (
                        cashbackWalletState && (
                          <div className="pay-bg-wallet">
                            <img src={wallet} alt="" width="50px" />{" "}
                            <h4 className="ml-2 mt-1">
                              <b>Cashback Wallet</b>
                            </h4>
                          </div>
                        )
                      ) : null}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
  const modalBodyPayBooking = (
    <div className="col-md-4 mobileHide con-sticky">
      <div className="trip-summary">
        <h1 className="trip-route text-center">Trip Summary</h1>
        <div className="d-flex">
          <p className="left-par">From </p>
          <p className="left-par ml-auto">
            <span>{userInfo?.departureName}</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">To </p>
          <p className="left-par ml-auto">
            <span>{userInfo?.arrivalName}</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">Date </p>
          <p className="left-par ml-auto">
            <span>{dateTimeFormat.format(routeDate)}</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">Time</p>
          <p className="left-par ml-auto">
            <span>{tripInfo?.departureTime}</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">Adult(s)</p>
          <p className="left-par ml-auto">
            <span>{userInfo?.noOfAdult}</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">Seat Number(s)</p>
          <p className="left-par ml-auto">
            <span>{userSelectedSeat.toString()}</span>{" "}
          </p>
        </div>
        {userSelectedSeatReturn === null ? (
          ""
        ) : (
          <div className="d-flex">
            <p className="left-par">Returned Seat Number(s)</p>
            <p className="left-par ml-auto">
              <span>{userSelectedSeatReturn?.toString()}</span>{" "}
            </p>
          </div>
        )}
        <div className="d-flex">
          <p className="left-par">Price</p>
          <p className="left-par ml-auto">
            <span>₦{nf.format(totalPayableAmount)}</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">Discount</p>
          <p className="left-par ml-auto">
            <span>0</span>{" "}
          </p>
        </div>
        <div className="d-flex">
          <p className="left-par">Total Amount</p>
          <p className="left-par ml-auto">
            <span style={{ fontSize: "24px" }}>
              ₦{nf.format(totalPayableAmount)}
            </span>{" "}
          </p>
        </div>
        {userInfo?.noOfAdult === "1" || userInfo?.noOfAdult === 1 ? (
          <Button
            text={"Pay"}
            handleButtonClick={checkEmail}
            type="button"
            btnstyle={{
              backgroundColor: "#E21D00",
              width: "70%",
              marginLeft: "15%",
            }}
            // disabled={
            //   !(
            //     fullName &&
            //     gender &&
            //     kinName &&
            //     value &&
            //     valueTwo &&
            //     email &&
            //     inputList
            //   )
            // }
          />
        ) : (
          <Button
            text={"Pay"}
            handleButtonClick={checkEmail}
            type="button"
            btnstyle={{
              backgroundColor: "#E21D00",
              width: "70%",
              marginLeft: "60px",
            }}
            // disabled={
            //   !(
            //     fullName &&
            //     gender &&
            //     kinName &&
            //     value &&
            //     valueTwo &&
            //     email &&
            //     inputList &&
            //     passengerTwo === true
            //   )
            // }
          />
        )}
      </div>
    </div>
  );
  const modalBodyPickup = (
    <div>
      <a
        className="pickup-image"
        href="https://play.google.com/store/apps/details?id=com.gigm"
      >
        <img src={PickupImage} alt="Download App For Pickup" />
      </a>
    </div>
  );

  const createInput = (el, index) => {
    const inputs = [];
    inputs?.push(
      <div className="stepform-card" key={index}>
        <h2 className="step-p">Passenger #{index + 2}</h2>
        <label className="label-auth">Full Name</label>
        <input
          type="text"
          placeholder="Enter Full Name"
          name="fullName"
          value={el?.fullName}
          onChange={(e) => handleInputChange(index, e)}
          className="multiple-input"
          required
        />
        <br />
        <br />
        <label className="con1">
          <span>Male</span>
          <input
            type="radio"
            name={`${index}-Gender`}
            value="0"
            onChange={(e) => handleInputChange(index, e)}
            required
          />
          <span className="checkmarkSpan"></span>
        </label>
        <label className="con1">
          <span>Female</span>
          <input
            type="radio"
            name={`${index}-Gender`}
            value="1"
            onChange={(e) => handleInputChange(index, e)}
            required
          />
          <span className="checkmarkSpan"></span>
        </label>
      </div>
    );

    return inputs;
  };

  return (
    <div>
      {/* <Script
              src="https://inlinepay.budpay.com/budpay-inline-custom.js"
              async
            ></Script> */}
      {loader ? (
        <>
          <Navbar />
          <Modal
            width={widthPay}
            height={height}
            visible={modalVisible}
            title={modalTitle}
            paragraph={modalPar}
            body={modalBody}
            handleClose={toggleModalClose}
          />

          <Modal
            width={width}
            height={heightThree}
            visible={modalVisibleAmount}
            body={modalBodyLowAmount}
            handleClose={toggleModalAmountClose}
          />

          <Modal
            width={width}
            height={heightThree}
            visible={modalVisiblePin}
            title={modalTitleTwo}
            paragraph={modalParTwo}
            body={modalBodyPin}
            handleClose={toggleModalPinClose}
          />
          <Modal
            width={width}
            height={height}
            visible={modalVisiblePickup}
            body={modalBodyPickup}
            handleClose={toggleModalPickupClose}
          />
          <Modal
            width={width}
            height={height}
            visible={modalVisiblePayBooking}
            body={modalBodyPayBooking}
            handleClose={toggleModalPayBooking}
          />
          <div className="container">
            <div className="dashboardArea">
              <SideBar />
              <div className="" style={{ width: "100%" }}>
                <MobileNavBar />
                <Loading isLoading={loadingLoading} />
                <>
                  <div className="col-md-12 text-center mb-3">
                    <h1 className="h1-route">
                      Hi{" "}
                      {loggedInUser === null
                        ? "Guest"
                        : loggedInUser?.FirstName}
                      , we just need few more details about you
                    </h1>
                  </div>
                  <Steps current={current} items={items} />
                  <div style={contentStyle}>{steps[current].content}</div>
                  {/* <div style={{ marginTop: 24 }}>
                    {current < steps.length - 1 && (
                      <Button type="primary" onClick={() => next()}>
                        Next
                      </Button>
                    )}
                    {current === steps.length - 1 && (
                      <Button
                        type="primary"
                        onClick={() => message.success("Processing complete!")}
                      >
                        Done
                      </Button>
                    )}
                    {current > 0 && (
                      <Button
                        style={{ margin: "0 8px" }}
                        onClick={() => prev()}
                      >
                        Previous
                      </Button>
                    )}
                  </div> */}
                </>
              </div>
            </div>
          </div>
          <Footer />
        </>
      ) : (
        <>
          {/* <p>Loading</p> */}
          <div
            style={{ background: "#67656500", paddingTop: "400px" }}
            className="text-center"
          >
            <div className="lds-default">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
export default DetailsComponent;
